import { withJsonFormsControlProps } from '@jsonforms/react';
import { MultipleChoiceGrid } from './MultipleChoiceGrid';

const MultipleChoiceGridControl = ({ data, handleChange, path, schema, errors, visible }) => {
  return (
    <MultipleChoiceGrid
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      rows={schema?.rows ?? []}
      columns={schema?.columns ?? []}
      description={schema?.description ?? ''}
      limit={schema?.limit_one_per_column ?? false}
      errors={errors}
      visible={visible}
    />
  );
};

export default withJsonFormsControlProps(MultipleChoiceGridControl);
